import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    // User display name
    name: '',
    // Dashboard title
    title: ''
  },
  mutations: {
    LOGIN (state, token) {
      state.token = token
    },
    LOGOUT (state) {
      state.token = null
      state.name = null
    },
    TITLE (state, title) {
      state.title = title
    },
    NAME (state, name) {
      state.name = name
    }
  },
  actions: {},
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
